
import * as types from './types';
import { implementSetAllNavTabDetailsMutation } from '../../../../dt-plugins/sidewindow/nav-tab';

// Mutations Object for AccountsRoyalty. Use it by importing accounts/types.js and calling commit() from  accounts/actions.js Action File.
export const costsMutations = {
  [types.CostData.SET.ALL](state, payload) {
    state.costData = payload;
  },

  [types.CostsList.SET.ALL](state, payload) {
    state.costsList = payload;
  },
  [types.CostsList.DELETE.SINGLE](state, payload) {
    // let list = state.costsList;
    // list = list.filter(e => e.invoice_id !== payload.invoice_id)
    // state.costsList = {
    //   costs: [
    //     ...list
    //   ]
    // }

    state.costsList = state.costsList?.filter(e => e.invoice_id !== payload.invoice_id);

  },
  // [types.AccountsRelatedContacts.SET.ALL](state,payload){
  //   state.accountsDetails.contacts=payload
  // },

  ...implementSetAllNavTabDetailsMutation(types.CostsDetails, 'costsDetails'),
}